import { renderInlineMarkdown } from "./inlineMd";

interface ListBlockProps {
	ordered?: boolean;
	items: string[];
}

export default function ListBlock({ ordered, items }: ListBlockProps) {
	const ListTag = ordered ? "ol" : "ul";
	return (
		<ListTag style={{ marginBottom: 12, paddingLeft: 24 }}>
			{items.map((item, i) => (
				<li key={i} style={{ marginBottom: 4 }}>
					{renderInlineMarkdown(item)}
				</li>
			))}
		</ListTag>
	);
}
